// components/WhatsAppFloatingButton.tsx
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloatingButton = () => {
  const phoneNumber = '918097588099';
  const message = 'Hello, I am interested in your service. Please provide more details.';
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center space-x-2 cursor-pointer animate-fade-in"
    >
        
      {/* WhatsApp Icon Round Button */}
      <div className="bg-[#25D366] hover:bg-green-600 p-3 rounded-full shadow-xl transition-all duration-300 flex items-center justify-center">
        <FaWhatsapp className="text-white text-2xl" />
      </div>

   
    </a>
  );
};

export default WhatsAppFloatingButton;
